export const selectEmployees = (state) =>
  state.companyEmployee?.employees || [];
export const selectEmployeeLoading = (state) =>
  state.companyEmployee?.loading || false;
export const selectEmployeeError = (state) =>
  state.companyEmployee?.error || null;
export const selectSelectedEmployee = (state) =>
  state.companyEmployee?.selectedEmployee || null;
export const selectEmployeeWorkloads = (state) =>
  state.companyEmployee?.workloads || [];
export const selectEmployeeWorkloadsLoading = (state) =>
  state.companyEmployee?.workloadsLoading || false;

export const selectOrgTree = (state) =>
  state.companyEmployee?.orgTree || [];
export const selectOrgTreeLoading = (state) =>
  state.companyEmployee?.orgTreeLoading || false;
export const selectOrgTreeError = (state) =>
  state.companyEmployee?.orgTreeError || null;
